import axiosInstance from "../api/axiosInstance";
import {
  DASHBOARD_TOTAL_ORDER_PLACED_TODAY,
  DASHBOARD_TOTAL_ORDER_COMPLETED_TODAY,
  DASHBOARD_TOTAL_PENDING_PICKLIST,
  DASHBOARD_TOTAL_PICKLIST_IN_CHECKER_PANEL,
  DASHBOARD_TOTAL_DISPATCH_PENDING,
  DASHBOARD_DISPATCH_DATA,
  DASHBOARD_WHATSAPP_LOGIN_STATUS,
  DASHBOARD_BACKEND_VERSION,
  DASHBOARD_PICKER_PACKER_STATS,
} from "../constants/API_URLs";

export const getTotalOrderPlacedToday = (): Promise<any> => {
  return axiosInstance.get(DASHBOARD_TOTAL_ORDER_PLACED_TODAY);
};

export const getTotalOrderCompletedToday = (): Promise<any> => {
  return axiosInstance.get(DASHBOARD_TOTAL_ORDER_COMPLETED_TODAY);
};

export const getTotalPendingPicklist = (): Promise<any> => {
  return axiosInstance.get(DASHBOARD_TOTAL_PENDING_PICKLIST);
};

export const getTotalPicklistInCheckerPanel = (): Promise<any> => {
  return axiosInstance.get(DASHBOARD_TOTAL_PICKLIST_IN_CHECKER_PANEL);
};

export const getTotalDispatchPending = (): Promise<any> => {
  return axiosInstance.get(DASHBOARD_TOTAL_DISPATCH_PENDING);
};

export const getDispatchData = (): Promise<any> => {
  return axiosInstance.get(DASHBOARD_DISPATCH_DATA);
};

export const getPickerPackerStats = (params?: {
  startDate?: string;
  endDate?: string;
}): Promise<any> => {
  return axiosInstance.get(DASHBOARD_PICKER_PACKER_STATS, { params });
};

export const getWhatsAppLoginStatus = (): Promise<any> => {
  return axiosInstance.get(DASHBOARD_WHATSAPP_LOGIN_STATUS);
};

export const getBackendVersion = (): Promise<any> => {
  return axiosInstance.get(DASHBOARD_BACKEND_VERSION);
};
